import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { GAService } from '@app/@shared/services/google-analytics.service';
import { Config } from '@core/config';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, AfterViewInit {
  public subCategories: any;
  public categories: any;
  public isMobile: boolean;
  public currentScreenWidth: number;
  public scrollbarWidth: string;

  constructor(public gaService: GAService, private router: Router) {
    this.scrollbarWidth = '15px';
    this.categories = Config.categories;
    this.subCategories = Config.subCategories;
    this.isMobile =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
  }

  ngOnInit(): void {
    this.onResize();
  }

  ngAfterViewInit() {
    this.scrollbarWidth = window.innerWidth - document.body.clientWidth + 'px';
  }

  isPanorama(): boolean {
    return this.router.url.includes('/panorama');
  }

  /**
   * Simple GA sending.
   * @param {string} event
   */
  public sendGaEvent(event: string, categ?: string, label?: string): void {
    this.gaService.sendEvent(event, categ, label);
  }

  /**
   * Set the currentScreenWidth attribute with actual screen width device.
   */
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.currentScreenWidth = this.isMobile
      ? window.screen.width
      : window.innerWidth;
  }
}
